const STORAGE_KEY = "nexus.lastSelectedLocation";

/**
 * Read the property and building last chosen while configuring an unassociated
 * unit in this browser, or null when nothing was chosen yet
 *
 */
export const readLastSelectedLocation = () => {
  try {
    const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
    if (!stored?.propertyUnid) {
      return null;
    }
    return { propertyUnid: stored.propertyUnid, buildingUnid: stored.buildingUnid || null };
  } catch {
    return null;
  }
};

/**
 * Remember the property and building chosen while configuring an unassociated
 * unit in this browser. The building belongs to the property, so it is stored
 * together with it and dropped when the property changes
 *
 */
export const saveLastSelectedLocation = ({ propertyUnid, buildingUnid }) => {
  if (!propertyUnid) {
    return;
  }
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ propertyUnid, buildingUnid: buildingUnid || null })
    );
  } catch {
    return;
  }
};
